import { useMemo } from "react";

import { queryGetUserAccessRight } from "@type/api/management";
import { useBusinessUnitStore } from "@type/store";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

import { TGetUserAccessRightReq } from "@type/api/management/types";
import { TBooleanRecord } from "types/index";

interface UseGetAppUserAccessRightProps {
  params?: TGetUserAccessRightReq;
}

export const useGetAppUserAccessRight = ({
  params,
}: UseGetAppUserAccessRightProps) => {
  const queryGetUserAccessRightKey = useMemo(() => {
    return queryGetUserAccessRight._key(params);
  }, [params]);

  const onSetAppAccessRight = useBusinessUnitStore(
    (state) => state.onSetAppAccessRight
  );

  const onSetAppAccessRightKey = useBusinessUnitStore(
    (state) => state.onSetAppAccessRightKey
  );

  const { isLoading } = useQueryWithCallbacks({
    queryKey: queryGetUserAccessRightKey,
    enabled: !!params?.idBu && !!params.data?.idUser,
    queryFn: () => queryGetUserAccessRight(params),
    onSuccess: (res) => {
      const objAccess: TBooleanRecord = {};
      for (const access of res.data.access) {
        objAccess[access.id] = !!access.status;
        for (const subAccess of access?.sub || []) {
          objAccess[subAccess.id] = !!subAccess.status;
        }
      }
      onSetAppAccessRight(objAccess);
      onSetAppAccessRightKey(queryGetUserAccessRightKey);
    },
  });

  return {
    isLoadingUserAccessRight: isLoading,
  };
};
